// extracted by mini-css-extract-plugin
export default {"campo":"styles_campo__Gbz3J","required":"styles_required__38-Ui","icon":"styles_icon__yY+kL","borderNone":"styles_borderNone__uNNvt","title":"styles_title__PStMV"};